import { useState } from 'react';

import type { CreateHandlerRequest, HandlerId } from '@vlabs/api/artemy/model';

import { useCreateHandlerMutation } from '../store.js';

type HandlerFactory<TValues> = (values: TValues) => unknown;

interface CreatedHandlerResult {
  handlerId?: HandlerId;
  handlerName?: string;
}

interface UseCreateHandlerWithResultReturn {
  closeResult: VoidFunction;
  createHandler: <TValues>(
    values: TValues,
    handlerFactory: HandlerFactory<TValues>,
  ) => Promise<void>;
  createdHandler?: CreatedHandlerResult;
}

function useCreateHandlerWithResult(): UseCreateHandlerWithResultReturn {
  const createHandlerMutation = useCreateHandlerMutation();
  const [createdHandler, setCreatedHandler] = useState<CreatedHandlerResult>();

  const createHandler = async <TValues>(
    values: TValues,
    handlerFactory: HandlerFactory<TValues>,
  ): Promise<void> => {
    const result = await createHandlerMutation.mutateAsync({
      data: handlerFactory(values) as CreateHandlerRequest,
    });

    setCreatedHandler({
      handlerId: result.handler_id,
      handlerName: (values as { description?: string })?.description,
    });
  };

  return {
    closeResult: () => setCreatedHandler(undefined),
    createHandler,
    createdHandler,
  };
}

export { useCreateHandlerWithResult };
